module.exports = __webpack_public_path__ + "static/img/three.aba4836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elephant/three.png
// module id = mfcQ
// module chunks = 1